import React, { useState, useEffect } from 'react';
import './gcg.scss';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import FooterId from '../../../footer/FooterId';
import FooterEn from '../../../footer/FooterEn';

const Gcg = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop();
  const [activeButton, setActiveButton] = useState(currentPath);
  const isIdPath = window.location.pathname.startsWith('/en');

  const handleButtonClick = (componentName) => {
    setActiveButton(componentName);
    navigate(`/corporate-governance/good-corporate-governance/${componentName.toLowerCase()}`);

    // Scroll only if current scroll position is less than 400px
    if (window.scrollY < 500) {
      window.scrollTo({
        top: 500,
        behavior: 'smooth',
      });
    } else {
      // Scroll to top if current scroll position is above 400px
      window.scrollTo({
        top: 500,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1300,
    });
  }, []);

  return (
    <>
      <div className="mainContainerGcg">
        <div className="menuStrukturGcg" data-aos="fade-right">
          <div className={`btnGcg ${activeButton === 'audit-committee' ? 'clicked' : ''}`} onClick={() => handleButtonClick('audit-committee')}>
            Komite Audit
          </div>
          <div className={`btnGcg ${activeButton === 'internal-audit-charter' ? 'clicked' : ''}`} onClick={() => handleButtonClick('internal-audit-charter')}>
            Piagam Audit Internal
          </div>
        </div>
        <div className="outletGcg">
          <Outlet />
        </div>
      </div>
      <div className="footer">{isIdPath ? <FooterEn /> : <FooterId />}</div>
    </>
  );
};

export default Gcg;
